import { SIGNALS_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";

import type {
    ISignalsWebhookSubscription,
    IWebhookSubscriptionBaseModel,
    IWebhookSubscriptionToggle,
} from "../types/row-data";

const WEBHOOK_SUBSCRIPTIONS_BASE_URL = `${SIGNALS_API_BASE_URL}/webhook-subscriptions`;

export type SignalsApiWebhookSubscriptionsService = {
    getWebhookSubscriptionsList(p: { cancellation: AbortSignal }): Promise<ISignalsWebhookSubscription[]>;
    saveWebhookSubscription(subscription: IWebhookSubscriptionBaseModel): Promise<ISignalsWebhookSubscription>;
    removeWebhookSubscription(subscriptionId: string): Promise<void>;
    testWebhookSubscription(subscription: IWebhookSubscriptionBaseModel): Promise<void>;
    webhookSubscriptionToggle(subscriptionToggle: IWebhookSubscriptionToggle): Promise<ISignalsWebhookSubscription>;
};

export const createSignalsApiWebhookSubscriptionsService = (
    fetchService: IFetchService,
): SignalsApiWebhookSubscriptionsService => ({
    getWebhookSubscriptionsList: createCancelable(
        (cancellation: AbortSignal): Promise<ISignalsWebhookSubscription[]> => {
            return fetchService.get(WEBHOOK_SUBSCRIPTIONS_BASE_URL, undefined, { cancellation });
        },
    ),
    saveWebhookSubscription: (subscription: IWebhookSubscriptionBaseModel): Promise<ISignalsWebhookSubscription> => {
        return fetchService.post(`${WEBHOOK_SUBSCRIPTIONS_BASE_URL}/save`, subscription);
    },
    removeWebhookSubscription: (subscriptionId: string): Promise<void> => {
        return fetchService.post(`${WEBHOOK_SUBSCRIPTIONS_BASE_URL}/archive`, {
            id: subscriptionId,
        });
    },
    testWebhookSubscription: (subscription: IWebhookSubscriptionBaseModel): Promise<void> => {
        return fetchService.post(`${WEBHOOK_SUBSCRIPTIONS_BASE_URL}/test`, subscription);
    },
    webhookSubscriptionToggle: (
        subscriptionToggle: IWebhookSubscriptionToggle,
    ): Promise<ISignalsWebhookSubscription> => {
        return fetchService.put(`${WEBHOOK_SUBSCRIPTIONS_BASE_URL}/activation-toggle`, subscriptionToggle);
    },
});
